<template>
  <div>
    <el-row :gutter="5">
      <el-col :span="24">
        <el-row :gutter="5">
          <el-col :span="3"
            ><el-input
              v-model="sBillNo"
              style="width:100%"
              placeholder="单号"
            ></el-input
          ></el-col>
          <el-col :span="3"
            ><el-input v-model="sDestination" placeholder="到站"></el-input
          ></el-col>
          <el-col :span="3">
            <el-date-picker
              v-model="sDeveliverDtFrom"
              type="date"
              style="width: 100%"
              placeholder="发货日期从"
              width="80px"
            ></el-date-picker>
          </el-col>
          <el-col :span="3">
            <el-date-picker
              v-model="sDeveliverDtTo"
              type="date"
              style="width: 100%"
              placeholder="发货日期到"
            ></el-date-picker>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :span="3">
            <el-select
              v-model="sGoodsStatus"
              placeholder="状态"
              clearable
              filterable
              style="width:100%"
            >
              <el-option
                v-for="status in statusItems"
                :key="status.Id"
                :label="status.Text"
                :value="status.Text"
              ></el-option>
            </el-select>
          </el-col>

          <el-col :span="3">
            <el-select
              v-model="sReceiptStatus"
              placeholder="回单状态"
              clearable
              filterable
              style="width:100%"
            >
              <el-option
                v-for="rstatus in rstatusitems"
                :key="rstatus.Id"
                :value="rstatus.Id"
                :label="rstatus.Text"
                >{{ rstatus.Text }}</el-option
              >
            </el-select>
          </el-col>
          <el-col :span="3">
            <el-date-picker
              v-model="sStoreDtFrom"
              type="date"
              style="width: 100%"
              placeholder="入仓日期从"
            ></el-date-picker>
          </el-col>
          <el-col :span="3">
            <el-date-picker
              v-model="sStoreDtTo"
              type="date"
              style="width: 100%"
              placeholder="入仓日期到"
            ></el-date-picker>
          </el-col>
          <el-col :span="3"
            ><el-input v-model="sPO" placeholder="PO"></el-input
          ></el-col>
          <el-col :span="2"
            ><el-button
              type="primary"
              icon="el-icon-search"
              @click="LoadData"
              style="width:100%"
              >查询</el-button
            ></el-col
          >
          <el-col :span="2"
            ><el-button
              type="primary"
              icon="el-icon-download"
              @click="handleExport"
              style="width:100%"
              >导出</el-button
            ></el-col
          >
        </el-row>
      </el-col>
    </el-row>
    <el-table
      :data="TransLogs"
      id="content"
      :height="tableHeight"
      :row-class-name="tableRowClassName"
      header-cell-style="background-color: #f2f2f2;color:#707070;font-weight: normal; background-image: linear-gradient(to bottom,#f8f8f8 0,#ececec 100%);
    background-repeat: repeat-x;"
    >
      <el-table-column type="expand">
        <template slot-scope="props">
          异常信息
          <el-table :data="props.row.TransLogExps" style="width: 800px;" border>
            <el-table-column type="index" width="50"></el-table-column>
            <el-table-column label="采购单号" prop="BillNo"></el-table-column>
            <el-table-column label="商品编码" prop="ProCode"></el-table-column>
            <el-table-column label="商品名称" prop="ProName"></el-table-column>
            <el-table-column
              label="差异数量"
              prop="DiffCount"
            ></el-table-column>
            <el-table-column
              label="异常原因"
              prop="ReasonDesc"
            ></el-table-column>
            <el-table-column
              label="跟踪处理情况"
              prop="ProcessRemark"
            ></el-table-column>
            <el-table-column
              label="退货处理状态"
              prop="BackRemarkDesc"
            ></el-table-column>
          </el-table>
          签收照片
          <div>
            <viewer :images="props.row.TransLogImages">
              <img
                v-for="image in props.row.TransLogImages"
                :src="image.FileGuid"
                :key="image.Id"
                style="max-height: 50px;max-width: 130px"
              />
            </viewer>
          </div>
        </template>
      </el-table-column>
      <el-table-column fixed prop="BillNo" label="单号"></el-table-column>
      <el-table-column
        prop="DeveliverDt"
        label="发货日期"
        width="80"
        :formatter="formatterController"
      ></el-table-column>
      <el-table-column
        prop="Destination"
        label="到站"
        width="50"
      ></el-table-column>
      <el-table-column
        prop="StoreDt"
        label="入仓日期"
        width="80"
        :formatter="formatterController"
      ></el-table-column>

      <el-table-column label="货物信息" align="center">
        <el-table-column
          prop="GoodsCount"
          label="件数"
          align="right"
          width="60"
        ></el-table-column>
        <el-table-column
          prop="GoodsStatus"
          label="状态"
          align="right"
          width="60"
        ></el-table-column>
        <el-table-column
          prop="GoodsCube"
          label="体积"
          align="right"
          :formatter="formatterDecimal"
          width="60"
        ></el-table-column>
        <el-table-column
          prop="GoodsWeight"
          label="重量"
          align="right"
          :formatter="formatterDecimal"
          width="60"
        ></el-table-column>
      </el-table-column>
      <el-table-column prop="PO" label="PO" width="200" show-overflow-tooltip></el-table-column>
      <el-table-column label="收货人信息" align="center">
        <el-table-column
          prop="Receiver"
          label="收货人"
          width="50"
        ></el-table-column>
        <el-table-column
          prop="ReceiverPhone"
          label="收货人电话"
        ></el-table-column>
        <el-table-column
          prop="ReceiverAddress"
          label="收货人地址"
          width="180"
        ></el-table-column>
      </el-table-column>
      <el-table-column
        prop="Comment"
        label="跟进结果"
        width="280"
      ></el-table-column>
      <el-table-column
        prop="Terminalinventory"
        label="库存"
        align="right"
      ></el-table-column>
      <el-table-column
        prop="ReceiptStatusDesc"
        label="回单状态"
        align="center"
      ></el-table-column>
    </el-table>
    <el-col :span="24">
      <el-pagination
        small
        @current-change="handleCurrentChange"
        :current-page="pageIndex"
        :page-size="pageSize"
        layout="total, prev, pager, next"
        :total="recordtotal"
      >
      </el-pagination>
    </el-col>
  </div>
</template>

<script>
import TransLogJs from "./TransLog.js";
export default TransLogJs;
</script>

<style scoped>
.el-row {
  margin-bottom: 5px;
  &:last-child {
    margin-bottom: 0;
  }
}

.el-table .warning-row {
  background: #f2f2f2;
}

.el-table .success-row {
  background: #fff;
}

.el-table {
  .el-table__expand-icon {
    .el-icon {
      font-size: 18px;
      font-weight: 900 !important;
      color: blue !important;
    }
  }
}

.tableheaderStyle {
  background-color: #f2f2f2;
  color: #707070;
  font-weight: normal;
  background-image: linear-gradient(to bottom, #f8f8f8 0, #ececec 100%);
  background-repeat: repeat-x;
}
.r {
  position: fixed;
  bottom: 0;
  background-color: rgb(162, 247, 228);
  width: 100%;
  margin-left: 10px;
}

.el-tooltip__popper{max-width :30%;}
</style>



// WEBPACK FOOTER //
// src/components/TransLog/TransLog.vue